export const STATUS_BADGE = {
  new: 'bg-blue-500/20 text-blue-300 border-blue-500/30',
  in_review: 'bg-amber-500/20 text-amber-300 border-amber-500/30',
  on_hold: 'bg-purple-500/20 text-purple-300 border-purple-500/30',
  posted: 'bg-green-500/20 text-green-300 border-green-500/30',
  rejected: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
  split: 'bg-sky-500/20 text-sky-200 border-sky-400/30',
  statement: 'bg-violet-500/20 text-violet-200 border-violet-400/30',
};
export const STATUS_LABEL = { new: 'New', in_review: 'In review', on_hold: 'On hold', posted: 'Posted', rejected: 'Rejected', split: 'Split', statement: 'Statement' };
export const OPEN_STATUSES = ['new', 'in_review', 'on_hold'];

// AI reads normally finish in ~10-15s. Past this margin we stop the spinner
// and surface a clear timed-out state with Retry (the document is untouched).
export const READ_TIMEOUT_MS = 60000;

const readInFlight = (it) => it?.extraction_status === 'pending' || it?.extraction_status === 'running';

export function isReadTimedOut(it) {
  if (!readInFlight(it)) return false;
  const started = it?.updated_at || it?.created_at;
  if (!started) return false;
  return Date.now() - new Date(started).getTime() > READ_TIMEOUT_MS;
}

/** Actively reading — false once it has timed out so spinners/polling stop. */
export const isReading = (it) => readInFlight(it) && !isReadTimedOut(it);

export function fmtUKDateTime(iso) {
  if (!iso) return '-';
  const d = new Date(iso);
  const p = n => String(n).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
}
export function fmtUKDate(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return d && m && y ? `${d}/${m}/${y}` : iso;
}
